module.exports = __webpack_public_path__ + "img/8-4.a27cb311.jpg";